export const TEXTS = {
  REQUEST_REPORT_BUTTON_TEXT: 'Запросить досрочный отчет',
};
